<template>
  <div>
    <Title :pages="[{ icon: 'sitemap', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn v-if="create_access" color="primary" class="mb-5" @click="newNode()">Crear {{ modal_title }}</v-btn>
      <v-btn v-if="create_access" class="mb-5 ml-3" outlined color="primary" @click="dialog_import = true">Importar estructura</v-btn>

      <ModalImportExcel v-if="create_access" modal_title="Importar estructura" :dialog="dialog_import" @updateDialog="(value) => (dialog_import = value)" @loadList="loadTree" />

      <v-card v-if="list_access" class="mb-5 px-4 py-6">
        <div class="row">
          <div class="col-md-8 d-flex align-center flex-wrap">
            <v-btn-toggle v-model="assignment" mandatory group class="oc-filter-toggle mr-4">
              <v-btn text :value="ASSIGNMENT_ALL">Todos</v-btn>
              <v-btn text value="assigned">Con responsable</v-btn>
              <v-btn text value="vacant">Vacantes</v-btn>
            </v-btn-toggle>
            <span class="mr-3 grey--text text--darken-2">Sucursal</span>
            <v-select v-model="sucursal_id" :items="sucursales_filter" item-text="name" item-value="id" :loading="loading_sucursales" outlined dense hide-details style="max-width: 240px"></v-select>
          </div>
          <div class="col-md-4 d-flex align-center justify-end">
            <v-btn outlined color="primary" class="mr-2" :loading="loading_export" @click="exportToExcel">Exportar</v-btn>
            <v-btn color="primary" @click="loadTree">Buscar</v-btn>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access" class="pa-6">
        <OrgChartDiagram
          :title="page_title"
          :tree="tree"
          :node_types="node_types"
          :loading="loading"
          :create_access="create_access"
          :update_access="update_access"
          :delete_access="delete_access"
          @editNode="editNode"
          @addChild="(node) => newNode(node.id)"
          @deleteNode="deleteNode"
          @assignResponsible="assignResponsible"
          @moveNode="moveNode"
        />
      </v-card>

      <ModalAssignResponsible v-if="update_access" :dialog="dialog_assign" :node="node_assign" @updateDialog="(value) => (dialog_assign = value)" @assigned="loadTree" />
      <DialogDelete :dialog_delete="dialog_delete" :subtext="DELETE_SUBTEXT" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { orgChartService } from "@/libs/ws/orgChartService";
import { generalService } from "@/libs/ws/generalService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import OrgChartDiagram from "./OrgChartDiagram.vue";
import ModalAssignResponsible from "./ModalAssignResponsible.vue";
import ModalImportExcel from "./ModalImportExcel.vue";
import { ASSIGNMENT_ALL, DELETE_SUBTEXT } from "@/constants/org_chart";


export default {
  components: { Title, DialogDelete, OrgChartDiagram, ModalAssignResponsible, ModalImportExcel },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      ASSIGNMENT_ALL: ASSIGNMENT_ALL,
      DELETE_SUBTEXT: DELETE_SUBTEXT,
      // Requeridos por GenericMixin.close()
      mainItem: {},
      defaultItem: {},
      service: orgChartService,
      page_title: "Organigrama",
      modal_title: "Puesto",
      tree: [],
      assignment: ASSIGNMENT_ALL,
      sucursal_id: null,
      sucursales: [],
      node_types: [],
      loading_sucursales: false,
      loading_export: false,
      dialog_import: false,
      dialog_assign: false,
      node_assign: null,
    };
  },
  computed: {
    sucursales_filter() {
      return [{ id: null, name: "Todas" }].concat(this.sucursales);
    },
  },
  mounted() {
    this.loadSucursales();
    this.loadNodeTypes();
    this.loadTree();
  },
  methods: {
    getFilterParams() {
      return {
        assignment: this.assignment != ASSIGNMENT_ALL ? this.assignment : null,
        sucursal_id: this.sucursal_id,
      };
    },
    loadSucursales() {
      this.loading_sucursales = true;
      generalService
        .filter({ enabled: true }, Constant.SECTION_SUCURSALES)
        .then((response) => {
          if (response.status) this.sucursales = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading_sucursales = false));
    },
    loadNodeTypes() {
      this.service
        .list_node_types()
        .then((response) => {
          if (response.status) this.node_types = response.result;
        })
        .catch((e) => console.log(e));
    },
    loadTree() {
      this.loading = true;
      this.service
        .tree(this.getFilterParams())
        .then((response) => {
          if (response.status) this.tree = response.result;
          else this.$toast.error(response.msg, "Error");
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    exportToExcel() {
      if (this.loading_export) return;
      this.loading_export = true;
      this.service
        .export_filter(this.getFilterParams())
        .then((response) => {
          if (Object.prototype.toString.call(response) != "[object ArrayBuffer]" && !response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          let blob = new Blob([response], { type: "application/vnd.ms-excel" });
          let link = document.createElement("a");
          link.download = "organigrama.xlsx";
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading_export = false));
    },
    newNode(parent_id = null) {
      this.$router.push({ path: "/" + Constant.SECTION_ORG_CHART + "/new", query: parent_id != null ? { parent_id } : {} });
    },
    editNode(node) {
      this.$router.push("/" + Constant.SECTION_ORG_CHART + "/" + node.id);
    },
    assignResponsible(node) {
      this.node_assign = node;
      this.dialog_assign = true;
    },
    moveNode({ node, parent }) {
      this.service
        .move({ id: node.id, parent_id: parent.id })
        .then((response) => {
          if (response.status) {
            this.$toast.success("«" + node.name + "» ahora depende de «" + parent.name + "».", "OK");
            this.loadTree();
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => console.log(e));
    },
    deleteNode(node) {
      this.deleteId = node.id;
      this.dialog_delete = true;
    },
    deleteItemConfirm() {
      this.dialog_delete = false;
      this.service
        .remove({ id: this.deleteId })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.loadTree();
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => console.log(e));
    },
  },
};
</script>
